import { Component, EventEmitter, Input, Output, OnDestroy, InjectionToken, Inject } from '@angular/core';
import { Config } from 'app/config.const';
import { combineLatest, debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';

export interface ISearch<T> {
	search(key: string, rows: T[]): T[];
}

export const SEARCH_FUNCTION_TOKEN = new InjectionToken<ISearch<any>>('SEARCH_FUNCTION_TOKEN');

@Component({
	selector: 'search',
	templateUrl: 'search.component.html',
	styleUrls: []
})
export class SearchComponent<T> implements OnDestroy {
	public term: string;

	private rows = new Subject<T[]>();

	private subscription: Subscription;

	@Input()
	set items(value: T[]) {
		this.search(null);
		this.rows.next(value);
	}

	@Output()
	filtered = new EventEmitter<T[]>();

	public readonly search: (term: string) => void;

	constructor(
		@Inject(SEARCH_FUNCTION_TOKEN)
		searchFunction: ISearch<T>
	) {

		const terms$ = new Subject<string>();

		this.search = (term: string) => { terms$.next(term) };

		this.subscription = terms$.pipe(
			debounceTime(Config.searchDebounceTime),
			combineLatest(this.rows))
			.subscribe(([term, subj]) => {
				if (term) {
					this.filtered.next(searchFunction.search(term, subj));
				} else {
					this.filtered.next(subj);
				}
			});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

}



// WEBPACK FOOTER //
// ./src/app/components/search/search.component.ts